import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
// import JobManagementTable from "./jobTable";
import { FilterIcon, MessageIconCover } from '../UIElements/svgIcons';
import { InfoBox } from '../designUi';
import { UserIconLarge } from '../UIElements/svg-icons';
import Roles from './Roles';
import PermittedUsers from './PermittedUsers';
import { UsersComponentProps } from '../../interface/users';
import UsersTopStats from './usersTopStats';

const GridUserRoles = ({
  usersList,
  isLoading,
  setPaginationState,
  paginationState,
}: UsersComponentProps) => {
  const theme = useTheme();
  const isMedium = useResponsive('down', 'md', 'xl');
  const isSmall = useResponsive('down', 'sm', 'xl');
  return (
    <Grid container>
      {/* <Grid
        item
        xs={isSmall ? 12 : 6}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        <Box>
          <Stack
            direction="row"
            justifyContent={"space-between"}
            sx={{ px: 2 }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
              }}
              gutterBottom
            >
              Roles
            </Typography>
           
          </Stack>
          <Roles />
        </Box>
      </Grid> */}
      <Grid
        item
        xs={isSmall ? 12 : 12}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        <Box sx={{}}>
          <Stack
            direction="row"
            justifyContent={'space-between'}
            sx={{ px: 3 }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
              }}
              gutterBottom
            >
              Permitted Users
            </Typography>
            {/* <Typography variant="caption" gutterBottom>
            Seel all
          </Typography> */}
          </Stack>
          <PermittedUsers
            paginationState={paginationState}
            setPaginationState={setPaginationState}
            usersList={usersList}
            isLoading={isLoading}
          />
        </Box>
      </Grid>{' '}
    </Grid>
  );
};

export default GridUserRoles;
